import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiNeutralFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 1.333C3.167 1.333 1.334 3.167 1.334 16S3.167 30.667 16 30.667 30.667 28.833 30.667 16 28.833 1.333 16 1.333m-4 20.134v2.4h8v-2.4zm11.334-7.6H18v-2.4h5.334zm-14.667 0H14v-2.4H8.667z"
            fill="currentColor"
        />
    </svg>
));
EmojiNeutralFilledSize32Glyph.displayName = 'EmojiNeutralFilledSize32Glyph';
